import boxImage from 'images/icon/systemSettings/box.svg';
import * as React from 'react';
import { getTranslate } from 'react-localize-redux';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { AAllBrands, ABrandFilter, AEmptyBrand } from '../../../atoms/filter/BrandFiltersAtom';
import { Brand } from '../../../containers_v2/globals/Model';
import { ReportFiltersContext } from '../../../containers_v2/reports/generic/generic';
import storeLang from '../../../helpers/storeLang';
import { translateToString } from '../../../styles/global/translate';
import Dropdown from '../../dropdown/Dropdown';
import { DropdownData, DropdownStyle } from '../../dropdown/model/Model';
import { GenericToolbarFilterProps } from '../ToolbarFilter';
import { getBrands } from './action';
import { GreySidely, SidelyBlack } from '../../../styles/global/css/Utils';

export const DROPDOWN_FILTER_STYLE: DropdownStyle = {
	width: '150px',
	optionWidth: '205px',
	fontSize: 12,
	optionFontColor: SidelyBlack,
	containerBorder: `1px solid color-mix(in oklab, ${SidelyBlack} 12.5%, transparent)`,
	arrowClassName: 'fas fa-caret-down mr-1',
	arrowColor: GreySidely,
	arrowFontSize: '12px'
};

function BrandFilter(props: GenericToolbarFilterProps & { withoutBrandOption: boolean }): JSX.Element {
	const translate = getTranslate(storeLang.getState().localize);

	const [atomBrands, setAtomBrands] = useRecoilState(ABrandFilter);
	const setAtomAllBrands = useSetRecoilState(AAllBrands);
	const [atomEmptyBrand, setAtomEmptyBrand] = useRecoilState(AEmptyBrand);

	const [brands, setBrands] = React.useState<Brand[]>([]);
	const [list, setList] = React.useState<DropdownData<number>[]>([]);

	const { filters, setFilters } = React.useContext(ReportFiltersContext);

	let filterBrands: { brands: number[], all: boolean };

	if (props.context && filters.my_filters && filters.my_filters.brands) {
		filterBrands = { all: false, brands: filters.my_filters.brands.brands };
	}

	React.useEffect(() => {
		getBrands().then(response => {
			setBrands(response);

			if (!props.context) {
				if (atomBrands != null) {
					if (atomBrands.length <= 0) {
						setAtomBrands(response.length <= 0 ? undefined : response);
					}
				} else {
					setAtomEmptyBrand(true);
					setAtomAllBrands(true);
					setAtomBrands([...response]);
				}
				const data = response.map(r => ({
					label: r.name,
					value: r.id,
					checked: (atomBrands != null) && atomBrands.length > 0 ? atomBrands.find(b => b.id === r.id) != undefined : true
				}));
				if (props.withoutBrandOption) {
					data.unshift({ label: translateToString('whitout_brand'), value: -1, checked: (atomEmptyBrand != null) ? atomEmptyBrand : true });
				}
				setList(data);
			} else {
				if (filterBrands && filterBrands.brands && filterBrands.brands.length <= 0) {
					setFilters(filters => ({ ...filters, my_filters: { ...filters.my_filters, brands: { brands: response.map(r => r.id), all: true } } }));
				}
				const data = response.map(r => ({
					label: r.name,
					value: r.id,
					checked: (filters.my_filters?.brands?.brands) ? filters.my_filters?.brands?.brands.includes(r.id) : true
				}));
				if (props.withoutBrandOption) {
					data.unshift({ label: translateToString('whitout_brand'), value: -1, checked: (filters.my_filters?.brands?.all) ? filters.my_filters?.brands?.includes(-1) : true });
				}
				setList(data);
			}
		});
	}, []);

	if (props.hidden) return <></>;

	function update(values: DropdownData<number>[]): void {
		list.forEach(v => v.checked = values.some(s => s.value === v.value && s.checked));
		setList([...list]);
		const emptyBrand = list.find(l => l.value === -1);
		if (emptyBrand) {
			setAtomEmptyBrand(emptyBrand.checked ?? false);
		}
		if (props.context) {
			const ids: number[] = brands.filter(b => list.find(nl => nl.value == b.id && nl.checked) != undefined).map(b => b.id);
			setFilters({ ...filters, my_filters: { ...filters.my_filters, brands: { brands: ids, all: list.every(nl => nl.checked) } } });
		} else {
			setAtomBrands(brands.filter(b => list.find(nl => nl.value == b.id && nl.checked) != undefined));
			setAtomAllBrands(list.every(nl => nl.checked));
		}
	}

	function getText(): string {
		const amount = list.filter(l => l.checked).length;
		return amount > 0 ? (amount === list.length ? translate('tool_bar.brand.all').toString() : `${amount} ${translate('tool_bar.brand.selectedBrand').toString()}`) : translate('tool_bar.brand.selectBrand').toString();
	}
	return <>
		{brands.length > 0 && <Dropdown
			dropdownStyle={{ ...DROPDOWN_FILTER_STYLE, height: '28px', inputMargin: '0 5px', inputPadding: '0 5px', width: props.fullScreen ? '100%' : DROPDOWN_FILTER_STYLE.width, containerWidth: props.fullScreen ? '100%' : DROPDOWN_FILTER_STYLE.containerWidth, optionHeight: '200px' }}
			datalist={list}
			readOnly
			checkbox
			checkboxAll
			defaultShowLabel={getText()}
			freezeShowLabel
			name='dropdown_scope_filter'
			onChange={update}
			image={boxImage}
		/>}
	</>;
}

export default BrandFilter;
